export default __webpack_public_path__ + "static/media/navigation-menu.a692f6b7.svg";